// extracted by mini-css-extract-plugin
export var layoutContainer = "_3v-0";
export var layoutContainerOpen = "_3v-3";
export var mainContent = "_3v-1";
export var panelLarge = "_3v-6";
export var panelMedium = "_3v-5";
export var panelSmall = "_3v-4";
export var slidePanel = "_3v-2";